import './style.scss';
import '../../../node_modules/swiper/swiper-bundle.min.css';
import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  isElemExist('.steps-guide-progressbar__circle', fillStersGuideProgressbars)
  isElemExist('.steps-guide-slider', initStepsGuideSlider)
  isElemExist('.lightbox', initSimpleLightbox)
});

function isElemExist(_el, _cb) {
  typeof _el === 'object' ? _el = [..._el] : _el;
  const elem = document.querySelector(_el);
  if (document.contains(elem)) {
    _cb();
  }
}

function fillStersGuideProgressbars () {
  const stepsGuides = document.querySelectorAll('.steps-guide-list')

  stepsGuides.forEach(stepsGuide => {
    const steps = stepsGuide.querySelectorAll('.steps-guide-item')

    steps.forEach((step, index) => {
      const stepProgressbarCircle = step.querySelector('.steps-guide-progressbar__circle')
      const stepProgressbarNum = step.querySelector('.steps-guide-progressbar__num')
      stepProgressbarCircle.style.setProperty('--progress', (index + 1) / steps.length * 100)
      stepProgressbarNum.textContent = (index + 1)
    })
  })
}

function initStepsGuideSlider () {
  const sliders = document.querySelectorAll('.steps-guide-slider');

  sliders.forEach(slider => {
    new Swiper(slider, {
      modules: [Navigation, Pagination, EffectFade],
      spaceBetween: 30,
      effect: "fade",
      autoHeight: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
    });
  });
}

function initSimpleLightbox () {
  const lightboxes = document.querySelectorAll('.lightbox');

  for (let i = 1; i < lightboxes.length; i++) {
    lightboxes[i].remove();
  }

  /* eslint-disable no-console */
  var body = document.body,
    lightbox = document.querySelector('.lightbox'),
    lightboxContent = lightbox.querySelector('.lightbox__content'),
    lightboxDesc = lightbox.querySelector('.lightbox__desc'),
    lightboxImages = [],
    photoLink = document.querySelectorAll('.steps-guide-slide__screenshot-link')

  function showLightbox (source, lightboxText) {
    body.classList.add('js-lightbox-loading');
    body.classList.remove('js-lightbox-active');
    body.classList.remove('js-lightbox-first');
    body.classList.remove('js-lightbox-last');

    lightboxContent.innerHTML = '<img src="' + source + '" />';
    if (lightboxText) lightboxDesc.innerHTML = lightboxText;
    body.classList.remove('js-lightbox-loading');
    body.classList.add('js-lightbox-active');
  }

  function hideLightbox () {
    body.classList.remove('js-lightbox-loading');
    body.classList.remove('js-lightbox-active');
    lightboxContent.innerHTML = '';
    lightboxDesc.innerHTML = '';
  }

  lightbox.addEventListener('click', function (event) {
    if ((event.target === this || event.target === this.querySelector('.loader') || event.target === this.querySelector('.close')) && (body.classList.contains('js-lightbox-loading') || body.classList.contains('js-lightbox-active'))) {
      hideLightbox()
    }
  })
  document.addEventListener('keyup', function (event) {
    if ((event.keyCode === 27 || event.keyCode === 33 || event.keyCode === 34) && (body.classList.contains('js-lightbox-loading') || body.classList.contains('js-lightbox-active'))) {
      hideLightbox()
    }
  })
  document.addEventListener('mousewheel', function () {
    if (body.classList.contains('js-lightbox-loading') || body.classList.contains('js-lightbox-active')) {
      hideLightbox()
    }
  })

  for (let pl = 0, pll = photoLink.length; pl < pll; pl++) {
    lightboxImages.push(photoLink[pl].getAttribute('data-src-full'));
    const lightboxText = photoLink[pl].closest('.steps-guide-slide').querySelector('.steps-guide-item__desc').innerHTML;

    photoLink[pl].addEventListener('click', function (event) {
      event.preventDefault();
      showLightbox(this.getAttribute('data-src-full'), lightboxText);
    })
  }
}